/*
 * Numéros de version des firmwares, partagés par les trois écrans.
 *
 * Le tri est le point délicat : les binaires s'appellent firmware_5.9.bin et
 * firmware_5.30.bin, et un tri alphabétique place le second AVANT le premier.
 * Proposer « la dernière version » exige donc une comparaison numérique.
 */

// Extrait un numéro de version ("5.07", "1.2.3") d'une chaîne quelconque : nom
// BLE, chaîne DIS 0x2a26 ou nom de fichier .bin. null si aucun trouvé.
export const extractVersion = (s?: string | null): string | null => {
  if (!s) return null;
  const m = s.match(/(\d+(?:\.\d+)+)/);
  return m ? m[1] : null;
};

// Compare segment par segment, en entiers : 5.30 > 5.9 > 5.0.
export const compareVersions = (a: string, b: string): number => {
  const pa = a.split(".").map((n) => parseInt(n, 10) || 0);
  const pb = b.split(".").map((n) => parseInt(n, 10) || 0);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d !== 0) return d;
  }
  return 0;
};

// Du plus récent au plus ancien ; un fichier sans numéro de version part en bas.
export const sortByVersionDesc = (list: string[]): string[] =>
  [...list].sort((a, b) =>
    compareVersions(extractVersion(b) ?? "0", extractVersion(a) ?? "0")
  );

// Listing HTML d'un dossier du serveur -> noms de fichiers .bin, les plus
// récents en tête. Le serveur OVH renvoie un index Apache, pas du JSON.
export const listerFirmwares = async (url: string): Promise<string[]> => {
  const reponse = await fetch(url);
  if (!reponse.ok) throw new Error(`HTTP ${reponse.status}`);
  const doc = new DOMParser().parseFromString(await reponse.text(), "text/html");
  return sortByVersionDesc(
    Array.from(doc.querySelectorAll("a"))
      .map((a) => a.getAttribute("href"))
      .filter((h): h is string => !!h && h.endsWith(".bin"))
  );
};
